module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049537_Acknowledgments#ack",
      "id": "rack"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049537_Killer#killer",
      "id": "rkiller"
    }
  }, [_c('i', [_vm._v("Killer of Sheep")]), _vm._v(": Charles Burnett and the Poetry of Oppression / David C. Wall and Michael T. Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Part01#part1",
      "id": "rpart1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 1: Situating "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(": Time / Place / Circumstance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter01#ch1",
      "id": "rch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Cinema and Black Liberation / David E. James")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter02#ch2",
      "id": "rch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Struggles for the "), _c('i', [_vm._v("Sign")]), _vm._v(" in the Black Atlantic: Los Angeles Collective of Black Filmmakers / Michael T. Martin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter03#ch3",
      "id": "rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Charles Burnett: A Reconsideration of Third Cinema / Amy Abugo Ongiri")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter04#ch4",
      "id": "rch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Charles Burnett: Consummate Cineaste / Michael T. Martin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Part02#part2",
      "id": "rpart2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 2: Reading "), _c('i', [_vm._v("Killer of Sheep")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter05#ch5",
      "id": "rch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Toward a Geo-Cinematic Hermeneutics: Representations of Los Angeles in Non-Industrial Cinema—"), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(" and "), _c('i', [_vm._v("Water and Power")]), _vm._v(" / David E. James")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter06#ch6",
      "id": "rch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("An Aesthetic Appropriate to Conditions: "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(", (Neo)Realism, and the Documentary Impulse / Paula J. Massood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter07#ch7",
      "id": "rch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "spaceb1"
  }, [_vm._v("Neorealism Meets the Blues in Charles Burnett’s "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(" / Keith Mehlinger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter08#ch8",
      "id": "rch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "spaceb1"
  }, [_c('i', [_vm._v("Killer of Sheep")]), _vm._v(" / James Naremore")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter09#ch9",
      "id": "rch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "spaceb1"
  }, [_c('i', [_vm._v("Killer of Sheep")]), _vm._v(" / Jeffrey Skoller")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-x"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Chapter10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "spaceb1"
  }, [_c('i', [_vm._v("Revenons à nos moutons")]), _vm._v(": Regarding Animals in Charles Burnett’s "), _c('i', [_vm._v("Killer of Sheep")]), _vm._v(" / Sarah O’Brien")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Screenplay#screen",
      "id": "rscreen",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Screenplay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Biography#bib",
      "id": "rbib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Biography and Filmography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049537_Index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24630c76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253049537_Contents.vue
// module id = 75
// module chunks = 0